import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL, SUPPRESS_ALL_GROWL } from "utils/constants";
import { sortCategoryGroupsWithMap } from "utils/Labels";

const initialState = {
	labels: [],
	categories: [],
	creatives: {},
	versions: {},

	advertiserTaxonomy: {
		isLoaded: false,
		hasErrorLoading: false,

		categories: [],
		allLabels: [],
		labelsByCategoryId: {},
	},

	isLoading: false,
};

export const LABELS_ACTIONS = {
	RESET_LABELS: "RESET_LABELS",

	LOAD_CREATIVE_LABELS_AJAX: "LOAD_CREATIVE_LABELS_AJAX",
	LOAD_CREATIVE_LABELS_SUCCESS: "LOAD_CREATIVE_LABELS_SUCCESS",
	LOAD_CREATIVE_LABELS_ERROR: "LOAD_CREATIVE_LABELS_ERROR",

	LOAD_VERSION_LABELS_AJAX: "LOAD_VERSION_LABELS_AJAX",
	LOAD_VERSION_LABELS_SUCCESS: "LOAD_VERSION_LABELS_SUCCESS",
	LOAD_VERSION_LABELS_ERROR: "LOAD_VERSION_LABELS_ERROR",

	LOAD_ADVERTISER_TAXONOMY_AJAX: "LOAD_ADVERTISER_TAXONOMY_AJAX",
	LOAD_ADVERTISER_TAXONOMY_SUCCESS: "LOAD_ADVERTISER_TAXONOMY_SUCCESS",
	LOAD_ADVERTISER_TAXONOMY_ERROR: "LOAD_ADVERTISER_TAXONOMY_ERROR",

	ADD_CREATIVE_LABELS_AJAX: "ADD_CREATIVE_LABELS_AJAX",
	ADD_CREATIVE_LABELS_SUCCESS: "ADD_CREATIVE_LABELS_SUCCESS",
	ADD_CREATIVE_LABELS_ERROR: "ADD_CREATIVE_LABELS_ERROR",

	DELETE_CREATIVE_LABELS_AJAX: "DELETE_CREATIVE_LABELS_AJAX",
	DELETE_CREATIVE_LABELS_SUCCESS: "DELETE_CREATIVE_LABELS_SUCCESS",
	DELETE_CREATIVE_LABELS_ERROR: "DELETE_CREATIVE_LABELS_ERROR",

	ADD_VERSION_LABELS_AJAX: "ADD_VERSION_LABELS_AJAX",
	ADD_VERSION_LABELS_SUCCESS: "ADD_VERSION_LABELS_SUCCESS",
	ADD_VERSION_LABELS_ERROR: "ADD_VERSION_LABELS_ERROR",

	DELETE_VERSION_LABELS_AJAX: "DELETE_VERSION_LABELS_AJAX",
	DELETE_VERSION_LABELS_SUCCESS: "DELETE_VERSION_LABELS_SUCCESS",
	DELETE_VERSION_LABELS_ERROR: "DELETE_VERSION_LABELS_ERROR",
};

export function clearLabels(){
	return (dispatch) => {
		dispatch({
			type: LABELS_ACTIONS.RESET_LABELS,
		});
		return Promise.resolve({ success: true });
	};
}

export function loadCreativeLabels(libraryId, creativeIds){
	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.LOAD_CREATIVE_LABELS_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/creatives/labels?creativeIds=${creativeIds}`,
				success: LABELS_ACTIONS.LOAD_CREATIVE_LABELS_SUCCESS,
				error: LABELS_ACTIONS.LOAD_CREATIVE_LABELS_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function loadVersionLabels(creativeId, versionIds){
	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.LOAD_VERSION_LABELS_AJAX,
			AJAX: {
				url: `ui/creatives/${creativeId}/versions/labels?versionIds=${versionIds}`,
				success: LABELS_ACTIONS.LOAD_VERSION_LABELS_SUCCESS,
				error: LABELS_ACTIONS.LOAD_VERSION_LABELS_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function addCreativeLabels(libraryId, creativeId, labelIds = []){
	const data = {
		creatives: [{
			id: creativeId,
			labels: labelIds.map(labelId => ({ labelId })),
		}],
	};

	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.ADD_CREATIVE_LABELS_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/creatives/labels`,
				method: "POST",
				data,
				success: LABELS_ACTIONS.ADD_CREATIVE_LABELS_SUCCESS,
				error: LABELS_ACTIONS.ADD_CREATIVE_LABELS_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function deleteCreativeLabels(creativeId, labelIds = []){
	const data = {
		labels: labelIds.map(labelId => ({ labelId })),
	};

	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.DELETE_CREATIVE_LABELS_AJAX,
			AJAX: {
				url: `ui/creatives/${creativeId}/labels/deletion`,
				method: "POST",
				data,
				success: LABELS_ACTIONS.DELETE_CREATIVE_LABELS_SUCCESS,
				error: LABELS_ACTIONS.DELETE_CREATIVE_LABELS_ERROR,
			},
			payload: {
				creativeId,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function addVersionLabels(creativeId, versionId, labelIds = []){
	const data = {
		versions: [{
			id: versionId,
			labels: labelIds.map(labelId => ({ labelId })),
		}],
	};

	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.ADD_VERSION_LABELS_AJAX,
			AJAX: {
				url: `ui/creatives/${creativeId}/versions/labels`,
				method: "POST",
				data,
				success: LABELS_ACTIONS.ADD_VERSION_LABELS_SUCCESS,
				error: LABELS_ACTIONS.ADD_VERSION_LABELS_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function deleteVersionLabels(versionId, labelIds = []){
	const data = {
		labels: labelIds.map(labelId => ({ labelId })),
	};

	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.DELETE_VERSION_LABELS_AJAX,
			AJAX: {
				url: `ui/versions/${versionId}/labels/deletion`,
				method: "POST",
				data,
				success: LABELS_ACTIONS.DELETE_VERSION_LABELS_SUCCESS,
				error: LABELS_ACTIONS.DELETE_VERSION_LABELS_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
			payload: {
				versionId,
			},
		});
	};
}

export function loadAdvertiserTaxonomy(advertiserId){
	return (dispatch) => {
		return dispatch({
			type: LABELS_ACTIONS.LOAD_ADVERTISER_TAXONOMY_AJAX,
			AJAX: {
				url: `ui/advertisers/${advertiserId}/creative-taxonomy`,
				gateway: "adm",
				success: LABELS_ACTIONS.LOAD_ADVERTISER_TAXONOMY_SUCCESS,
				error: LABELS_ACTIONS.LOAD_ADVERTISER_TAXONOMY_ERROR,
			},
			meta: SUPPRESS_ALL_GROWL,
		});
	};
}

const actionCreators = {
	clearLabels,

	loadCreativeLabels,
	addCreativeLabels,
	deleteCreativeLabels,

	loadVersionLabels,
	addVersionLabels,
	deleteVersionLabels,

	loadAdvertiserTaxonomy,
};

const handlers = {
	[LABELS_ACTIONS.RESET_LABELS]: reset,

	[LABELS_ACTIONS.LOAD_CREATIVE_LABELS_AJAX]: initLoadCreativeLabels,
	[LABELS_ACTIONS.LOAD_CREATIVE_LABELS_SUCCESS]: successLoadCreativeLabels,
	[LABELS_ACTIONS.LOAD_CREATIVE_LABELS_ERROR]: errorLoadCreativeLabels,

	[LABELS_ACTIONS.LOAD_VERSION_LABELS_AJAX]: initLoadVersionLabels,
	[LABELS_ACTIONS.LOAD_VERSION_LABELS_SUCCESS]: successLoadVersionLabels,
	[LABELS_ACTIONS.LOAD_VERSION_LABELS_ERROR]: errorLoadVersionLabels,

	[LABELS_ACTIONS.LOAD_ADVERTISER_TAXONOMY_AJAX]: initLoadAdvertiserTaxonomy,
	[LABELS_ACTIONS.LOAD_ADVERTISER_TAXONOMY_SUCCESS]: successLoadAdvertiserTaxonomy,
	[LABELS_ACTIONS.LOAD_ADVERTISER_TAXONOMY_ERROR]: errorLoadAdvertiserTaxonomy,

	[LABELS_ACTIONS.ADD_CREATIVE_LABELS_SUCCESS]: successAddCreativeLabels,
	[LABELS_ACTIONS.DELETE_CREATIVE_LABELS_SUCCESS]: successDeleteCreativeLabels,

	[LABELS_ACTIONS.ADD_VERSION_LABELS_SUCCESS]: successAddVersionLabels,
	[LABELS_ACTIONS.DELETE_VERSION_LABELS_SUCCESS]: successDeleteVersionLabels,
};

export function reset(state, action){
	return {
		...initialState,
	};
}

function initLoadCreativeLabels(state, action){
	return {
		...state,
		isLoading: true,
	};
}

export function successLoadCreativeLabels(state, action){
	const rawCreatives = action.payload?.data?.creatives || [];
	const creatives = rawCreatives.reduce((prev, creative) => {
		const { id } = creative || {};
		prev[`${id}`] = creative.labels || []; // Cast id to a string so we don't allocate a huge sparse array
		return prev;
	}, {});

	return {
		...state,
		creatives,
		isLoading: false,
	};
}

function errorLoadCreativeLabels(state, action){
	return {
		...state,
		isLoading: false,
	};
}

function successAddCreativeLabels(state, action){
	const payloadCreatives = action.payload?.data?.creatives || [];

	const creatives = payloadCreatives.reduce((prev, creative) => {
		const { id } = creative || {};
		prev[`${id}`] = creative.labels || [];
		return prev;
	}, { ...state.creatives });

	return {
		...state,
		creatives,
	};
}

function successDeleteCreativeLabels(state, action){
	const deletedIds = action.payload?.data?.deleted || [];
	const { creativeId } = action.payload.original || {};
	const creativeLabels = state.creatives[`${creativeId}`] || [];

	const updatedLabels = deletedIds.reduce((prev, labelId) => {
		return prev.filter(label => label.labelId !== labelId);
	}, creativeLabels);

	return {
		...state,
		creatives: {
			...state.creatives,
			[`${creativeId}`]: updatedLabels,
		},
	};
}

function initLoadVersionLabels(state, action){
	return {
		...state,
		isLoading: true,
	};
}

export function successLoadVersionLabels(state, action){
	const rawVersions = action.payload?.data?.versions || [];
	const versions = rawVersions.reduce((prev, version) => {
		const { id } = version || {};
		prev[`${id}`] = version.labels || []; // Cast id to a string so we don't allocate a huge sparse array
		return prev;
	}, {});

	return {
		...state,
		versions,
		isLoading: false,
	};
}

function errorLoadVersionLabels(state, action){
	return {
		...state,
		isLoading: false,
	};
}

function successAddVersionLabels(state, action){
	const payloadVersions = action.payload?.data?.versions || [];

	const versions = payloadVersions.reduce((prev, version) => {
		const { id } = version || {};
		prev[`${id}`] = version.labels || [];
		return prev;
	}, { ...state.versions });

	return {
		...state,
		versions,
	};
}

function successDeleteVersionLabels(state, action){
	const deletedIds = action.payload?.data?.deleted || [];
	const { versionId } = action.payload.original || {};
	const versionLabels = state.versions[`${versionId}`] || [];

	const updatedLabels = deletedIds.reduce((prev, labelId) => {
		return prev.filter(label => label.labelId !== labelId);
	}, versionLabels);

	return {
		...state,
		versions: {
			...state.versions,
			[`${versionId}`]: updatedLabels,
		},
	};
}

function initLoadAdvertiserTaxonomy(state, action){
	return {
		...state,
		advertiserTaxonomy: {
			isLoaded: false,
			hasErrorLoading: false,
		},
	};
}

function errorLoadAdvertiserTaxonomy(state, action){
	return {
		...state,
		advertiserTaxonomy: {
			isLoaded: true,
			hasErrorLoading: true,
		},
	};
}

export function successLoadAdvertiserTaxonomy(state, action){
	/*
		Payload data looks like:
		```
			{
				"advertiser": {
					"id": 100,
					"name": "Advertiser Name",
					"creativeTaxonomy": {
						"autoClassification": "Standard"
						"maxCredits": 250,
						"remainingCredits": 100
					}
				},
				"categoryGroups": [
					{
						"id": 101,
						"name": "test category group"
						"categories": [
							{
								"id": 102,
								"name": "test category"
								"type": "Universal",
								"labels": [
									{
										"id": 400,
										"name": "test label",
										"prettyName": "Test Label"
									}
								]
							}
						]
					}
				]
			}
		```

		We want a flat list of categories, a flat list of all labels, and a map of labels by category id.

		The flat lists need to be sorted in a particular order depending on group name, and then alphabetically.

		The group order is:
			Advertiser
			Anything starting with "Vertical:"
			General Content
			Design
			other group names alphabetical

		The labels within each group are sorted alphabetically by `prettyName`
	*/

	const categoryGroups = action.payload?.data?.categoryGroups || [];
	categoryGroups.sort(sortCategoryGroupsWithMap(item => item.name)); /*
		Sort the groups ahead of time, since multiple sort orders depend on the group order.
		When we iterate over the sorted groups, we'll get some of the ordering for free,
		and then we'll just have to worry about sorting each subset by name.
	*/

	// Flatten categories
	const categories = categoryGroups.reduce((prev, group) => {
		const categories = [...(group?.categories || [])];
		categories.sort((catA, catB) => catA.name.localeCompare(catB.name));
		prev.push(...categories);
		return prev;
	}, []);

	const allLabels = [];
	const labelsByCategoryId = categories.reduce((prev, category) => {
		const labels = [...(category?.labels || [])];
		labels.sort((labelA, labelB) => labelA.prettyName.localeCompare(labelB.prettyName));

		prev[`${category.id}`] = labels;
		allLabels.push(...labels); // We just build the list of all labels as we iterate through them

		return prev;
	}, {});

	return {
		...state,
		advertiserTaxonomy: {
			isLoaded: true,
			hasErrorLoading: false,
			categories,
			labelsByCategoryId,
			allLabels,
		},
	};
}

let reducerConfig = {
	typeRoot: "LABELS",
	initialState,
	actionTypes: LABELS_ACTIONS,
	actionCreators,
	handlers,
};

export default createReducer(
	reducerConfig.initialState,
	reducerConfig.handlers
);
export const Labels = reducerConfig.actionCreators;
export const PRIVATE = {
	...reducerConfig.handlers,
};
